import { contentTypes } from './types';

const setUserTypes = (payload: any) => ({
  type: contentTypes.SET_USER_TYPES,
  payload,
});

const setUserRoles = (payload: any) => ({
  type: contentTypes.SET_USER_ROLES,
  payload,
});

const setCircuits = (payload: any) => ({
  type: contentTypes.SET_CIRCUITS,
  payload,
});

const getUserRoles = (onSuccess: (...args: any[]) => void, onError: (...args: any[]) => void) => ({
  type: contentTypes.GET_USER_ROLES,
  onSuccess,
  onError,
});

export { setUserTypes, setUserRoles, setCircuits, getUserRoles };
